import { cn } from "@/lib/cn";

interface AnimatedBgProps {
  className?: string;
  variant?: "default" | "subtle";
}

/**
 * Cosmic gradient orb background.
 * Place once at the root of a layout. Pure CSS, no canvas.
 */
export function AnimatedBg({ className, variant = "default" }: AnimatedBgProps) {
  const opacity = variant === "subtle" ? "opacity-50" : "opacity-100";
  return (
    <div
      aria-hidden
      className={cn(
        "pointer-events-none fixed inset-0 -z-10 overflow-hidden",
        opacity,
        className,
      )}
    >
      {/* Base radial wash */}
      <div
        className="animate-pulse-orb absolute inset-[-50%]"
        style={{
          background: `
            radial-gradient(circle at 20% 80%, var(--color-brand-blue-soft) 0%, transparent 40%),
            radial-gradient(circle at 80% 20%, var(--color-brand-purple-soft) 0%, transparent 40%),
            radial-gradient(circle at 40% 40%, var(--color-brand-pink-soft) 0%, transparent 30%)
          `,
        }}
      />
      {/* Floating glow orbs */}
      <div className="animate-float-slow absolute left-[10%] top-[15%] size-96 rounded-full bg-[var(--color-brand-blue)] opacity-10 blur-[120px]" />
      <div
        className="animate-float-slow absolute right-[12%] bottom-[18%] size-80 rounded-full bg-[var(--color-brand-purple)] opacity-10 blur-[120px]"
        style={{ animationDelay: "-3s" }}
      />
      <div
        className="animate-float-slow absolute left-[40%] top-[60%] size-72 rounded-full bg-[var(--color-brand-pink)] opacity-[0.08] blur-[100px]"
        style={{ animationDelay: "-1.5s" }}
      />
      {/* Top vignette */}
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-[var(--color-bg-base)] to-transparent" />
      {/* Bottom vignette */}
      <div className="absolute inset-x-0 bottom-0 h-40 bg-gradient-to-t from-[var(--color-bg-base)] to-transparent" />
    </div>
  );
}
